import { render } from "./DisplayMarkets.vue?vue&type=template&id=cce7a608"
import script from "./DisplayMarkets.vue?vue&type=script&lang=js"
export * from "./DisplayMarkets.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__